// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2PN_W","validationTips":"StatementDescriptor_validationTips__o_sni"};